import { render, staticRenderFns } from "./studentEvaluation.vue?vue&type=template&id=dc0cea7e&scoped=true"
import script from "./studentEvaluation.vue?vue&type=script&lang=js"
export * from "./studentEvaluation.vue?vue&type=script&lang=js"
import style0 from "./studentEvaluation.vue?vue&type=style&index=0&id=dc0cea7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0cea7e",
  null
  
)

export default component.exports